

/* 是否是公司邮箱*/
const isXimalayaEmail = (str)=>{
  const reg = /^[a-z0-9](?:[-_.+]?[a-z0-9]+)*@ximalaya\.com$/i;
  return reg.test(str.trim());
}

const validatePhone = (number) => {
  const reg = /^(0|86|17951)?(13[0-9]|15[0-9]|17[0-8]|18[0-9]|14[57]|199)[0-9]{8}$/
  return reg.test(number)
}

const validateidCardNo = (number) => {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return reg.test(number)
}

const validatePassword = (str) => {
  const reg = /^([A-Z]|[a-z]|[0-9]|[`\-\=[];,.\/~!@#$%\^*()_+}{:?]){6,20}$/
  return reg.test(str.trim())
}

/* 合法uri*/
const validateURL = (textval) => {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母*/
const validateLowerCase = (str) => {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 验证key*/
// export function validateKey(str) {
//     var reg = /^[a-z_\-:]+$/;
//     return reg.test(str);
// }

/* 大写字母*/
const validateUpperCase = (str) => {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
const validatAlphabets = (str) => {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}


export {isXimalayaEmail, validatePhone, validateidCardNo, validatePassword, validateURL, validateLowerCase, validateUpperCase, validatAlphabets}




// WEBPACK FOOTER //
// ./src/utils/validate.js